import React from "react"
import Link from "gatsby-link"
import SEO from '../../components/SEO'
import SVGInline from 'react-svg-inline'

import cover from "../../../static/img/servicii/servicii-administrare-tehnica-large.jpg"

class Page extends React.Component {
  render() {
    const pageSEO = {
      title: "Servicii administrare tehnica imobile",
      description: "Oferim servicii de top in administrare tehnica imobile Bucuresti",
      path: "/servicii/administrare-tehnica/"
    };
    return (
      <div className="o-page__content">
        <SEO pageSEO={pageSEO} />
        <div className="c-section-gradient">
          <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
            <h1 className="c-page__heading">Servicii administrare tehnica</h1>
          </div>
        </div>

        <div className="o-container u-pv-20 u-pv-30@tablet u-bg-white">
          <div className="o-container o-container--text u-ph-0">

            <img className="u-mb-20" src={cover} alt="servicii administrare tehnica"/>

            <ol>
              <li>Verificarea proprietății comune a asociatiei, constatarea defecțiunilor apărute si propunerea catre Comitetul Executiv de solutii tehnice pentru remedierea acestora.</li>
              <li>Verificarea proprietății individuale, numai cu acordul proprietarilor si constatarea defecțiunilor apărute. Informarea Comitetului Executiv in vederea adoptariii de solutii tehnice pentru remedierea acestora.</li>
              <li>Prezentarea de oferte privind serviciile de curatenie, intretinere spatii verzi, paza, intretinere interfon, lift, pompe de apa, centrale de bloc, supraveghere video, etc. pentru aprobarea de catre Adunarea Generala a asociatiei sau catre Comitetul Executiv, dupa caz.</li>
              <li>Achizitionarea materialelor pentru întreținerea și repararea defectiunilor curente aparute pe proprietatea comuna a asociației. </li>
              <li>Verificarea  respectarii de catre furnizorii de servicii a contractelor.</li>
              <li>Supravegherea lucrărilor de reparații și participarea alaturi de un membru al Comitetului Executiv la recepția acestora.</li>
              <li>Verificarea si repartizarea facturilor emise de catre furnizorii de de energie electrică,  apă, etc, conform legii si normelor de aplicare.</li>
              <li>Verificarea periodica a personalului angajat al asociatiei privind sarcina de munca specificata in fisa postului. Aducarea la cunostinta Comitetului Executiv despre eventuale nereguli aparute.</li>
            </ol>

            <p className="u-color-grey-500 u-mt-30">* Pretul serviciilor tehnice se calculeaza functie de:</p>
            <ul className="u-color-grey-500">
              <li>disponibil pentru avarii 24 de ore pe zi, 7 zile pe săptămână.</li>
              <li>disponibil pentru avarii  8 ore pe zi 08.00 – 16.00 ( fara sambata, duminca si sarbatorile legale)</li>
            </ul>



            <div className="u-text-center">
              <Link to="/preturi/" className="c-button u-mt-30">
                Solicita o oferta personalizata
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Page




// WEBPACK FOOTER //
// ./src/pages/servicii/administrare-tehnica.js